import { http } from '../../../../api/http';
import type { SolicitudCompra } from '../types/solicitudCompra.types';

export class SolicitudCompraService {
  private static readonly BASE = '/compras/solicitud-compra';

  public static async getAll(): Promise<SolicitudCompra[]> {
    const response = await http.get(this.BASE);
    return response.data;
  }

  public static async getById(id: number): Promise<SolicitudCompra> {
    const response = await http.get(`${this.BASE}/${id}`);
    return response.data;
  }

  public static async save(data: SolicitudCompra): Promise<SolicitudCompra> {
    const response = await http.post(this.BASE, data);
    return response.data;
  }

  public static async delete(id: number): Promise<boolean> {
    await http.delete(`${this.BASE}/${id}`);
    return true;
  }

  public static async aprobar(id: number, idUsuarioAprueba: number): Promise<SolicitudCompra> {
    const response = await http.post(`${this.BASE}/${id}/aprobar?idUsuarioAprueba=${idUsuarioAprueba}`);
    return response.data;
  }
}
